const Index = () => import('@/App')
const Class1 = () => import('@/views/Class1.vue')
const Class2 = () => import('@/views/Class2.vue')
const Class3 = () => import('@/views/Class3.vue')
const Class4 = () => import('@/views/Class4.vue')
const Class5 = () => import('@/views/Class5.vue')
const Class6 = () => import('@/views/Class6.vue')
const Class7 = () => import('@/views/Class7.vue')
const Class8 = () => import('@/views/Class8.vue')
const Class9 = () => import('@/views/Class9.vue')
const Class10 = () => import('@/views/Class10.vue')
const Class11 = () => import('@/views/Class11.vue')
const Class12 = () => import('@/views/Class12.vue')
const Class13 = () => import('@/views/Class13.vue')
const Class14 = () => import('@/views/Class14.vue')
const Class15 = () => import('@/views/Class15.vue')
const Class16 = () => import('@/views/Class16.vue')
const Class17 = () => import('@/views/Class17.vue')
const Class18 = () => import('@/views/Class18.vue')
const Class19 = () => import('@/views/Class19.vue')
const Class20 = () => import('@/views/Class20.vue')
const Class21 = () => import('@/views/Class21.vue')
const Class22 = () => import('@/views/Class22.vue')
const Class23 = () => import('@/views/Class23.vue')
const Class24 = () => import('@/views/Class24.vue')
const Class25 = () => import('@/views/Class25.vue')
const Class26 = () => import('@/views/Class26.vue')
const Class116 = () => import('@/views/Class116.vue')
const ExpertList = () => import('@/views/ExpertList.vue')
const Expert = () => import('@/views/Expert.vue')
const ResourceDetail = () => import('@/views/ResourceDetail.vue')
const MiniProgram = () => import('@/views/MiniProgram.vue')

const routes = [
  // {
  //   path: '',
  //   redirect: '/index'
  // },
  {
    path: '/college/:collegeID',
    name: 'index',
    component: Index,
    children: [
      {
        path: 'class1/:instanceID',
        name: 'class1',
        component: Class1
      },
      {
        path: 'class2/:instanceID',
        name: 'class2',
        component: Class2
      },
      {
        path: 'class3/:instanceID',
        name: 'class3',
        component: Class3
      },
      {
        path: 'class4/:instanceID',
        name: 'class4',
        component: Class4
      },
      {
        path: 'class5/:instanceID',
        name: 'class5',
        component: Class5
      },
      {
        path: 'class6/:instanceID',
        name: 'class6',
        component: Class6
      },
      {
        path: 'class7/:instanceID',
        name: 'class7',
        component: Class7
      },
      {
        path: 'class8/:instanceID',
        name: 'class8',
        component: Class8
      },
      {
        path: 'class9/:instanceID',
        name: 'class9',
        component: Class9
      },
      {
        path: 'class10/:instanceID',
        name: 'class10',
        component: Class10
      },
      {
        path: 'class11/:instanceID',
        name: 'class11',
        component: Class11
      },
      {
        path: 'class12/:instanceID',
        name: 'class12',
        component: Class12
      },
      {
        path: 'class13/:instanceID',
        name: 'class13',
        component: Class13
      },
      {
        path: 'class14/:instanceID',
        name: 'class14',
        component: Class14
      },
      {
        path: 'class15/:instanceID',
        name: 'class15',
        component: Class15
      },
      {
        path: 'class16/:instanceID',
        name: 'class16',
        component: Class16
      },
      {
        path: 'class17/:instanceID',
        name: 'class17',
        component: Class17
      },
      {
        path: 'class18/:instanceID',
        name: 'class18',
        component: Class18
      },
      {
        path: 'class19/:instanceID',
        name: 'class19',
        component: Class19
      },
      {
        path: 'class20/:instanceID',
        name: 'class20',
        component: Class20
      },
      {
        path: 'class21/:instanceID',
        name: 'class21',
        component: Class21
      },
      {
        path: 'class22/:instanceID',
        name: 'class22',
        component: Class22
      },
      {
        path: 'class23/:instanceID',
        name: 'class23',
        component: Class23
      },
      {
        path: 'class24/:instanceID',
        name: 'class24',
        component: Class24
      },
      {
        path: 'class25/:instanceID',
        name: 'class25',
        component: Class25
      },
      {
        path: 'class26/:instanceID',
        name: 'class26',
        component: Class26
      },
      {
        path: 'class116/:instanceID',
        name: 'class116',
        component: Class116
      },
      {
        path: 'experts',
        name: 'expertList',
        component: ExpertList
      },
      {
        path: 'experts/:expertID',
        name: 'experts',
        component: Expert
      },
      {
        path: 'resources/:resID/details/:detID',
        name: 'resourceDetail',
        component: ResourceDetail
      },
      {
        path: 'miniProgram',
        name: 'MiniProgram',
        component: MiniProgram
      }
    ]
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/common.js